import * as yup from 'yup';

const AddAutomationEventSchema = yup.object({
  name: yup.string().required('Event type is required'),
  // reference: yup.string().required('Reference is required'),
  ruleName: yup.string().required('Name is required'),
});

export { AddAutomationEventSchema };
